<template>
  <span aria-hidden="true" class="hidden" />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue"
import {
  initializeCapgoUpdatePrompt,
  teardownCapgoUpdatePrompt
} from "@/mobile_app/services/capgo-update-service"

onMounted(() => {
  void initializeCapgoUpdatePrompt()
})

onUnmounted(() => {
  void teardownCapgoUpdatePrompt()
})
</script>
